import { createFileRoute, redirect } from '@tanstack/react-router';

/** /taxonomy is a container — land on Product Taxonomy so the URL names the page. */
export const Route = createFileRoute('/_authenticated/_tenant/taxonomy/')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/taxonomy/products', search });
  },
});
